import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, RefreshCw } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Admin() {
  const [key, setKey] = useState(localStorage.getItem("jsh_admin_key") || "");
  const [authed, setAuthed] = useState(false);
  const [items, setItems] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const load = async (k) => {
    setLoading(true); setError("");
    try {
      const res = await fetch(`${API}/enquiries`, { headers: { "X-Admin-Key": k } });
      if (res.status === 401) { setError("Invalid admin key"); setAuthed(false); return; }
      const data = await res.json();
      setItems(data); setAuthed(true);
      localStorage.setItem("jsh_admin_key", k);
    } catch { setError("Could not load enquiries"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[var(--bg-soft)]">
      <div className="mx-auto max-w-5xl px-4 py-12 lg:px-8">
        <Link to="/" className="inline-flex items-center gap-2 text-sm font-bold text-[var(--navy)]"><ArrowLeft size={16} /> Home</Link>
        <h1 className="mt-6 font-head text-3xl font-extrabold tracking-tight text-[var(--navy)]">Enquiries Dashboard</h1>

        {!authed ? (
          <div className="mt-8 max-w-md rounded-3xl border border-slate-200 bg-white p-7">
            <label className="text-sm font-semibold text-[var(--navy)]">Admin Key</label>
            <input data-testid="admin-key-input" type="password" value={key} onChange={(e) => setKey(e.target.value)}
              className="mt-2 w-full rounded-xl border border-slate-300 px-4 py-3 text-sm outline-none focus:border-[var(--navy)]" placeholder="Enter admin key" />
            {error && <p className="mt-2 text-sm font-semibold text-[var(--red)]" data-testid="admin-error">{error}</p>}
            <button data-testid="admin-login" onClick={() => load(key)} disabled={loading}
              className="mt-4 w-full rounded-full bg-[var(--navy)] py-3 text-sm font-bold text-white transition-all hover:scale-[1.02] disabled:opacity-60">
              {loading ? "Checking..." : "View Enquiries"}
            </button>
          </div>
        ) : (
          <div className="mt-8">
            <div className="mb-4 flex items-center justify-between">
              <p className="text-sm font-semibold text-[var(--slate)]" data-testid="admin-count">{items.length} enquiries</p>
              <button onClick={() => load(key)} className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-sm font-bold text-[var(--navy)] ring-1 ring-slate-200"><RefreshCw size={14} /> Refresh</button>
            </div>
            <div className="space-y-3" data-testid="admin-list">
              {items.map((e) => (
                <div key={e.id} className="rounded-2xl border border-slate-200 bg-white p-5">
                  <div className="flex flex-wrap items-center justify-between gap-2">
                    <span className="font-head text-lg font-bold text-[var(--navy)]">{e.name}</span>
                    <a href={`tel:${e.phone}`} className="text-sm font-bold text-[var(--green)]">{e.phone}</a>
                  </div>
                  <div className="mt-2 grid gap-1 text-sm text-[var(--slate)] sm:grid-cols-2">
                    {e.service && <p><b>Service:</b> {e.service}</p>}
                    {e.preferred_date && <p><b>Preferred date:</b> {e.preferred_date}</p>}
                  </div>
                  {e.message && <p className="mt-2 text-sm text-[var(--slate)]">{e.message}</p>}
                  <p className="mt-2 text-xs text-slate-400">{new Date(e.created_at).toLocaleString()}</p>
                </div>
              ))}
              {items.length === 0 && <p className="text-sm text-slate-400">No enquiries yet.</p>}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
